import {DomainObject} from 'shared/store';
import { computed, observable, makeObservable } from 'mobx';
import {fullName} from 'shared/tools';

class AdminInvitation extends DomainObject {
  id;
  firstName;
  lastName;
  assignedRoles;
  email;
  expiresAt;
  partner;

  _relations = {
    _dates: ['expiresAt']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      firstName: observable,
      lastName: observable,
      assignedRoles: observable,
      email: observable,
      expiresAt: observable,
      partner: observable,
      name: computed
    });

    this.merge(other);
  }

  get name() {
    return fullName(this);
  }
}

export default AdminInvitation;
